import { render, staticRenderFns } from "./DomainName.vue?vue&type=template&id=b59474da"
import script from "./DomainName.vue?vue&type=script&lang=ts"
export * from "./DomainName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports